var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "span",
      { class: `badge badge-${_vm.salaryRateClasses[_vm.rate ?? 0]}` },
      [_vm._v(_vm._s(_vm.salaryRateTitle[_vm.rate ?? 0]))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }